module.exports = __webpack_public_path__ + "static/media/orders-shot-3.ad0a85f6.png";